import { render, staticRenderFns } from "./Operationrecord.vue?vue&type=template&id=2c7a063c"
import script from "./Operationrecord.vue?vue&type=script&lang=js"
export * from "./Operationrecord.vue?vue&type=script&lang=js"
import style0 from "./Operationrecord.vue?vue&type=style&index=0&id=2c7a063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports